import React, { useState, useMemo } from 'react'
import Text from '../../atoms/text/Text'
import VerticalGroup from '../../atoms/verticalgroup/VerticalGroup'
import InlineGroup from '../../atoms/inlinegroup/InlineGroup'
import Icon from '../../atoms/icon/Icon'
import Image from '../../atoms/image/Image'
import ArcherMan from '../../../assets/results/ArcherMan.png'
import Law from '../../../assets/results/law.png'
import ResultsTable from './table/ResultsTable'
import { TeamsWithColours } from './RoundResults'
import { round, thousandSeparator } from '../model/utils/formatters'

import './RoundResultsTablePage.scss'
import { useResultsContext } from './context/context'

interface Props {
  teams: TeamsWithColours[]
  data: ModelAPI.Reporting.TeamAndAmount[]
}

const RoundResultsRegulatoryCapitalInterventions: React.FC<Props> = ({
  data,
  teams
}) => {
  const context = useResultsContext()
  const { sortedCapitalFromHighestToLowest } = useMemo(() => {
    const sortedCapitalFromHighestToLowest = data.filter(a => a.amount > 0).sort((a, b) => b.amount - a.amount)
    return { sortedCapitalFromHighestToLowest }
  }, [data])

  const [showRow, setShowRow] = useState(context.noAnimations ? 0 : sortedCapitalFromHighestToLowest.length)


  return (
    <>
      {sortedCapitalFromHighestToLowest.length === 0 ? (
        <VerticalGroup full center wide>
          <Text size="6xl" bold className='mb-2' colour='primaryDark'>Great Capital Management</Text>
          <Text size="4xl" bold colour='blue'>No Bank's required Regulator Capital Intervention</Text>
          <InlineGroup fullHeight center verticalCenter>
            <Image src={ArcherMan} alt='Archor Man' style={{width: '55%'}}></Image>
          </InlineGroup>
        </VerticalGroup>
      ) : (
        <VerticalGroup full center wide>
          <Text size="6xl" bold className='mb-2' colour='primaryDark'>Regulatory Capital Intervention</Text>
          <Text size="4xl" bold colour='blue' className='mb-4'>
        Insufficiently Capitalised Banks
          </Text>
          <InlineGroup spread fullHeight verticalCenter>
            <VerticalGroup center className='mr-10'>
              <Icon type='slide' size={64} colour='blue'></Icon>
            </VerticalGroup>
            <VerticalGroup style={{ width: '100%', height: '100%' }}>
              <ResultsTable id='999'>
                <thead>
                  <tr>
                    <th>BANK</th>
                    <th>AMOUNT($bn)</th>
                  </tr>
                </thead>
                <tbody onClick={() => setShowRow(showRow - 1)}>
                  {sortedCapitalFromHighestToLowest.map((cap, i) => {
                    const teamForTable = teams.find((t) => t.teamId === cap.teamId)

                    return (
                      <tr key={i} className={showRow <= i ? 'show-bids' : 'no-show-options'}>
                        <td style={{ color: `${teamForTable?.colour}` }}>{teamForTable?.teamName}</td>
                        <td>{thousandSeparator(round(cap.amount / 1000, 0))}</td>
                      </tr>
                    )
                  })}
                </tbody>
              </ResultsTable>
              {/* Added so you know to click on table body to display data */}
              <InlineGroup block center className='executive-decisions-card' >
                <Text center colour='primaryDark' className='mt-2'>Click on table row to display data.</Text>
              </InlineGroup>
            </VerticalGroup>
            <VerticalGroup center className='ml-10'>
              <Image src={Law} alt='Law' size={64}></Image>
            </VerticalGroup>
          </InlineGroup>
        </VerticalGroup>
      )}

    </>
  )
}

export default RoundResultsRegulatoryCapitalInterventions